<template>
  <div class="changeStatus">
    <section>
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        label-suffix=":"
        style="padding-bottom: 50px;"
        class="demo-ruleForm"
      >
        <li class="flex_input" v-if="this.$route.query.key=='手机号'||this.$route.query.key=='密码'">
          <div class="lable_left">
            <span class="redText">※</span> 手机号：
          </div>
          <el-form-item class="input_right" prop="phone">
            <el-input placeholder="请输入联系电话" readonly v-model="form.phone" type="text"/>
          </el-form-item>
        </li>
        <li class="flex_input" v-if="this.$route.query.key=='手机号'||this.$route.query.key=='密码'">
          <div class="lable_left">
            <span class="redText">※</span> 验证码：
          </div>
          <el-form-item class="input_right" prop="captcha">
            <el-input placeholder="验证码" style="width: 60%;" v-model="form.captcha" type="text"/>
            <button :disabled="disabled" type='button' @click.stop="getYzm" class="yzmBtn" style="width: 38%;">{{msg}}</button>
          </el-form-item>
        </li>
        <li class="flex_input" v-if="this.$route.query.key=='手机号'">
          <div class="lable_left">
            <span class="redText">※</span> 新手机号：
          </div>
          <el-form-item class="input_right" prop="sjh">
            <el-input placeholder="请输入联系电话" v-model="form.sjh" type="text"/>
          </el-form-item>
        </li>
        <li class="flex_input" v-if="this.$route.query.key=='邮箱'">
          <div class="lable_left">
            <span class="redText">※</span> 邮箱：
          </div>
          <el-form-item class="input_right" prop="yx">
            <el-input placeholder="请输入邮箱" v-model="form.yx" type="text"/>
          </el-form-item>
        </li>
        <li class="flex_input" v-if="this.$route.query.key=='密码'">
          <div class="lable_left">
            <span class="redText">※</span> 密码：
          </div>
          <el-form-item class="input_right" prop="pwd">
            <el-input placeholder="请输入密码（6位）" v-model="form.pwd" type="password"/>
          </el-form-item>
        </li>
        <li class="flex_input" v-if="this.$route.query.key=='身份证号'">
          <div class="lable_left">
            <span class="redText">※</span> 身份证号：
          </div>
          <el-form-item class="input_right" prop="sfzh">
            <el-input placeholder="请输入身份证号" v-model="form.sfzh"/>
          </el-form-item>
        </li>
      </el-form>
      <button class="btn_bx" type='button' @click.stop="changeStatus">
        提 交
      </button>
    </section>
  </div>
</template>

<script>
  import {findWechatBind, getCaptcha, getUser, updateWechatBind} from "@/api";
  export function validateEMail(rule, value,callback) {
    const reg =/^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/;
    if(value==''||value==undefined||value==null){
      callback();
    }else{
      if (!reg.test(value)){
        callback(new Error('请输入正确的邮箱'));
      } else {
        callback();
      }
    }
  }
  export default {
    data() {
      return {
        value: [],
        options: [],
        form: {},
        rules: {
          mobNo: [{
            required: true, message: '必填'
          }],
          captcha: [
            {
              required: true, message: '必填'
            }
          ],
          sjh: [
            {
              required: true, message: '必填'
            },
            {
              required: true, max: 11,min:11,message: '请输入11位有效手机号',trigger:'blur'
            }
          ],
          sfzh: [
            {
              required: true, message: '必填'
            },
            {
              required: true, max: 18,min:18,message: '请输入18位有效身份证号',trigger:'blur'
            }
          ],
          yx: [
            {
              required: true, message: '必填'
            },
            { validator: validateEMail, message: '邮箱格式不正确，请重新输入', trigger: 'blur' }
          ],
          pwd: [
            {
              required: true, message: '必填'
            },
            {
              required: true, max: 6,min:6,message: '请输入6位',trigger:'blur'
            }
          ],
        },
        maxtime: 60, // 一个小时，按秒计算，自己调整!
        timer: null,
        msg: '获取验证码',
        disabled: false,
      };
    },
    mounted() {
      this.getUser()
    },
    methods: {
      getUser() {
        getUser({
          code: this.$route.query.code
        }).then(res=>{
          this.$set(this.form,'phone',res.data.mobNo)
        })
        findWechatBind({
          customerId: this.$route.query.userId
        }).then((res) => {
          if(this.$route.query.key=='邮箱'&&res.data.email) {
            this.$set(this.form,'yx',res.data.email)
          }
        });
      },
      getYzm() {
        var reg_tel = /^(1)\d{10}$/;
        if(!reg_tel.test(this.form.phone)) {
          this.$toast('请输入正确的手机号码')
          return
        }
        let params = {
          sysType: 0,
          phone: this.form.phone,
        }
        getCaptcha(params).then(res=>{
          if(res.code=='0000') {
            this.maxtime = 60
            this.disabled = true
            this.timer = setInterval(() => {
              this.CountDown()
            }, 1000)
          }
        })
      },
      CountDown() {
        if (this.maxtime > 0) {
          let seconds = this.maxtime;
          this.msg = +seconds + "s" + '后获取';
          --this.maxtime;
        } else {
          clearInterval(this.timer);
          this.msg = '获取验证码'
          this.disabled = false
        }
      },
      changeStatus() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            let params = {
              customerId: this.$route.query.userId,
              captcha: this.form.captcha,
              key: this.$route.query.key,
            }
            if(this.$route.query.key=='手机号'||this.$route.query.key=='密码') {
              params.phone = this.form.phone
            }
            switch (this.$route.query.key) {
              case '手机号': params.value = this.form.sjh
                    break;
              case '密码': params.value = this.form.pwd
                    break;
              case '邮箱': params.value = this.form.yx
                    break;
              case '身份证号': params.value = this.form.sfzh
                    break;
            }
            updateWechatBind(params).then(res => {
              if (res.code == '0000') {
                this.$toast("操作成功");
                this.$router.go(-1)
              }
            })
          }

        })

      },
    }
    ,
  }
  ;
</script>

<style>
  .changeStatus {
    padding: 3%;
    min-height: 90%;
    background: #fff;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    height: 90%;
  }
  .yzmBtn{
    border: 1px solid #C2E7B0;
    border-radius: 3px;
    line-height: 26px;
    background: #F0F9EB;
    color: #67C23A;
    font-size: 12px;
    /*background: #000;*/
  }
  .xy{
    background: #fff;
    height: 80vh;
    width: 90%;
    border-radius: 5px;
    overflow-y: auto;
    /*margin-left: 5%;*/
    padding: 5px;
  }
  .changeStatus .mint-cell-wrapper {
    font-size: 14px !important;
  }

  .changeStatus .buleText {
    color: #1E88C7;
    font-size: 12px;
  }

  .changeStatus v.mask {
    position: fixed;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, .4);
  }

  .changeStatus .btn_bx {
    width: 100%;
    /*margin-top: 3rem;*/
    font-size: 1rem;
    height: 2.5rem;
    background: #47c34d;
    border-radius: 3px;
  }

  header, footer {
    height: 60px;
    line-height: 60px;

    /*text-align:center;*/
  }

  header {
    margin-bottom: 5px;
    background-color: #fff;

  }

  section {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: 100%;
    overflow: auto; /* winphone8和android4+ */
    -webkit-overflow-scrolling: touch; /* ios5+ */
  }

  .sfzsl {
    width: 90%;
    height: 80vh;
    left: 5%;
    border-radius: 10px;
    position: absolute;
  }

  .redText {
    color: red;
  }

  .lable_left {
    width: 100px;
    color: black;
  }

  .flex_input {
    display: flex;
    line-height: 40px;
  }

  .changeStatus li {
    line-height: 40px;
    display: flex;
    border-bottom: 1px solid #F7F6F7;
  }

  .li_flex {
    justify-content: space-between;
  }

  .lable_right {
    color: #949393;
  }

  .greyText {
    color: #8c939d;
    margin-right: 10px;
  }

  .input_right {
    flex: 1;
    color: black;
  }

  .changeStatus .el-input__inner {
    padding: 0 !important;
  }

  .changeStatus .input_right input, .input_right textarea {
    border: none;
    outline: none;
    float: 1;
    margin-top: 5px;
  }

  .changeStatus .el-form-item {
    margin-bottom: 0 !important;
  }

  .itemList {
    /* border-bottom: 1px solid #fcfcfc; */
    color: #646262;
    /* padding-left: 8%; */
  }

  /*.mint-cell-wrapper {*/
  /*  padding: 0 !important;*/
  /*}*/
  .item {
    /* border-bottom: 1px solid #f1f1f1;
    padding-bottom: 20px; */
  }

  .uploader-file {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .uploader-file:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100%;
    height: 178px;
    display: block;
    margin-top: 25px;
  }

  .file {
    width: 90%;
    height: 30px;
    position: relative;
    display: inline-block;
    background: #FBFDFF;
    border: 1px #C0CCDA dashed;
    border-radius: 4px;
    padding: 4px 12px;
    overflow: hidden;
    color: #1E88C7;
    text-decoration: none;
    text-indent: 0;
    text-align: center;
    line-height: 30px;
  }

  .file input {
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
  }

  .file:hover {
    background: #FBFDFF;
    border-color: #AADFFD;
    color: #004974;
    text-decoration: none;
  }

  .imgDiv {
    position: relative;
  }

  .error_icon {
    position: absolute;
    font-size: 25px;
    right: 0px;
    top: 0px;
    z-index: 999999;
    color: #f00;
  }

</style>



// WEBPACK FOOTER //
// src/view/ywbl/wsfz/yhxxxg.vue